import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Heading1 } from "../../common/components/styled/styled";
import EntriesList from "./EntriesList";
import { NewEntryTalentData } from "./entriesAPI";

type Props = {
  newEntryTalentData?: NewEntryTalentData;
  isReadOnly: boolean;
};

const EntriesPage = ({ newEntryTalentData, isReadOnly }: Props) => {
  const { t } = useTranslation();

  return (
    <Box data-testid="entries-page-root">
      <Heading1>{t("common:entries")}</Heading1>
      <EntriesList
        newEntryTalentData={newEntryTalentData}
        isReadOnly={isReadOnly}
      />
    </Box>
  );
};

export default EntriesPage;
